import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { OriginadorDTO } from '../../../shared/dto/originadorDTO';
import Spinner from '../../../shared/spinner';
import { Button, Row, Col } from 'react-bootstrap';
import OriginadorService from '../../../services/originadorService';
import ViaCepService from '../../../services/viaCepService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import MatrizService from '../../../services/matrizService';
import { Matriz } from '../../../shared/model/matriz';
import ImageUploader from '../../../shared/imagemUpload';
import ColorPicker from '../../../shared/corUpload';
import { Originador } from '../../../shared/model/originador';

function OriginadorInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const [idMatriz, setIdMatriz] = useState('');
  const [matrizes, setMatrizes] = useState<Matriz[]>([]);
  const [razaoSocial, setRazaoSocial] = useState('');
  const [sigla, setSigla] = useState('');
  const [emails, setEmails] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [localidade, setLocalidade] = useState('');
  const [uf, setUf] = useState('');
  const [codigoExterno, setCodigoExterno] = useState('');
  const [loading, setLoading] = useState(false);

  const [logoBase64, setLogoBase64] = useState<string | null>(null);

  const [corPrincipal, setCorPrincipal] = useState<string>('#000000');
  const [corSecundaria, setCorSecundaria] = useState<string>('#000000');
  const [corTexto, setCorTexto] = useState<string>('#000000');
  const [corCabecalho, setCorCabecalho] = useState<string>('#000000');
  const [corTabela, setCorTabela] = useState<string>('#000000');

  const [codigoBanco, setCodigoBanco] = useState('');
  const [nomeBanco, setNomeBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [digitoConta, setDigitoConta] = useState('');
  const [tipoConta, setTipoConta] = useState('CORRENTE');
  const [camaraCentralizadora, setCamaraCentralizadora] = useState('018');
  const [chavePix, setChavePix] = useState('');

  const [cartaDedEmail, setCartaDedEmail] = useState('');
  const [cartaDedWhatsapp, setCartaDedWhatsapp] = useState('');
  const [cartaDedContato, setCartaDedContato] = useState('');

  const originadorService: OriginadorService = new OriginadorService();
  const viaCepService: ViaCepService = new ViaCepService();
  const matrizService: MatrizService = new MatrizService();

  const explicacoesPagamento: { [key: string]: string } = {
    '018': 'TED (STR): Transferência Eletrônica Disponível convencional. Utilize para contas de bancos diferentes. O crédito geralmente ocorre no mesmo dia se enviado até o horário de corte (17h).',
    '000': 'Mesmo Banco (CC): Crédito em Conta Corrente. Utilize SOMENTE quando o banco de origem (pagador) for o mesmo do banco de destino (favorecido). Processamento mais rápido e sem custos de TED.',
    '009': 'PIX: Pagamento Instantâneo. Obrigatório informar a Chave PIX. Disponível 24/7.',
    '888': 'TED (CIP): Modalidade específica de TED via Câmara Interbancária de Pagamentos (menos comum que o STR 018).'
  };

  const listarMatrizesAtivas = async () => {
    try {
      const response = await matrizService.listarTodasMatrizesAtivas();
      setMatrizes(response.data);
      if (tipo === 'inclusao' && response.data.length > 0) {
        setIdMatriz(response.data[0].id!.toString());
      }
    } catch (err) {
      console.error(err);
    }
  };

  const listarOriginadorPorId = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await originadorService.listarOriginadorPorId(id!);
      const jsonOriginador = response.data;

      setIdMatriz(jsonOriginador.idMatriz.toString());
      setSigla(jsonOriginador.nome);        
      setRazaoSocial(jsonOriginador.razaoSocial);
      setEmails(jsonOriginador.email);
      setCodigoExterno(jsonOriginador.codigoExterno);
      setTelefoneComercial(jsonOriginador.telefoneComercial);
      setTelefoneCelular(jsonOriginador.telefoneCelular);

      if (jsonOriginador.enderecoDTO) {
        setCep(jsonOriginador.enderecoDTO.cep);
        setLogradouro(jsonOriginador.enderecoDTO.logradouro);
        setNumero(jsonOriginador.enderecoDTO.numero);
        setComplemento(jsonOriginador.enderecoDTO.complemento);
        setBairro(jsonOriginador.enderecoDTO.bairro);
        setLocalidade(jsonOriginador.enderecoDTO.localidade);
        setUf(jsonOriginador.enderecoDTO.uf);
      }

      if (jsonOriginador.logoBase64) {
        setLogoBase64(jsonOriginador.logoBase64);
      }
      setCorPrincipal(jsonOriginador.corPrincipal || '#000000');
      setCorSecundaria(jsonOriginador.corSecundaria || '#000000');
      setCorTexto(jsonOriginador.corTexto || '#000000');
      setCorCabecalho(jsonOriginador.corCabecalho || '#000000');
      setCorTabela(jsonOriginador.corTabela || '#000000');

      setCodigoBanco(jsonOriginador.codigoBanco || '');
      setNomeBanco(jsonOriginador.nomeBanco || '');
      setAgencia(jsonOriginador.agencia || '');
      setConta(jsonOriginador.conta || '');
      setDigitoConta(jsonOriginador.digitoConta || '');
      setTipoConta(jsonOriginador.tipoConta || 'CORRENTE');
      setCamaraCentralizadora(jsonOriginador.camaraCentralizadora || '018');
      setChavePix(jsonOriginador.chavePix || '');

      setCartaDedEmail(jsonOriginador.cartaDedEmail || '');
      setCartaDedWhatsapp(jsonOriginador.cartaDedWhatsapp || '');
      setCartaDedContato(jsonOriginador.cartaDedContato || '');

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogoChange = (file: File | null) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogoBase64(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setLogoBase64(null);
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setLoading(true);

    const endereco = new EnderecoDTO();
    endereco.cep = cep;
    endereco.logradouro = logradouro;
    endereco.numero = numero;
    endereco.complemento = complemento;
    endereco.bairro = bairro;
    endereco.uf = uf;
    endereco.localidade = localidade;

    const originadorDTO: any = new OriginadorDTO(); 
    originadorDTO.idMatriz = idMatriz;
    originadorDTO.id = id!;
    originadorDTO.nome = sigla;  
    originadorDTO.razaoSocial = razaoSocial;
    originadorDTO.email = emails;
    originadorDTO.enderecoDTO = endereco;
    originadorDTO.telefoneComercial = telefoneComercial;
    originadorDTO.telefoneCelular = telefoneCelular;
    originadorDTO.codigoExterno = codigoExterno;
    originadorDTO.corPrincipal = corPrincipal;
    originadorDTO.corSecundaria = corSecundaria;
    originadorDTO.corTexto = corTexto;
    originadorDTO.corCabecalho = corCabecalho;
    originadorDTO.corTabela = corTabela;
    originadorDTO.logoBase64 = logoBase64;

    originadorDTO.codigoBanco = codigoBanco;
    originadorDTO.nomeBanco = nomeBanco;
    originadorDTO.agencia = agencia;
    originadorDTO.conta = conta;
    originadorDTO.digitoConta = digitoConta;
    originadorDTO.tipoConta = tipoConta;
    originadorDTO.camaraCentralizadora = camaraCentralizadora;
    originadorDTO.chavePix = chavePix;

    originadorDTO.cartaDedEmail = cartaDedEmail;
    originadorDTO.cartaDedWhatsapp = cartaDedWhatsapp;
    originadorDTO.cartaDedContato = cartaDedContato;


    try {
      await originadorService.incluirAlterarOriginador(originadorDTO);
      setAlert({ message: `${Originador.DESCRITIVO_GERAL} salva com sucesso!`, type: 'success' });
    } catch (err: any) {
      setAlert({ message: err.response?.data || 'Erro ao salvar originador', type: 'error' });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const limparCampos = () => {
    setSigla('');
    setEmails('');
    setTelefoneComercial('');
    setTelefoneCelular('');
    setCep('');
    setLogradouro('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setLocalidade('');
    setUf('');
    setCodigoExterno('');
    setLogoBase64(null);
    setCorPrincipal('#000000');

    setCodigoBanco('');
    setNomeBanco('');
    setAgencia('');
    setConta('');
    setDigitoConta('');
    setTipoConta('CORRENTE');
    setCamaraCentralizadora('018');
    setChavePix('');

    setCartaDedEmail('');
    setCartaDedWhatsapp('');
    setCartaDedContato('');
  };

  const viaCep = async (cepValue: string) => {
    const cepSemMascara = cepValue.replace(/\D/g, '');
    if (cepSemMascara.length === 8) {
      setLoading(true);
      try {
        const response = await viaCepService.viaCep(cepSemMascara);
        const jsonViaCep = response.data;
        setLogradouro(jsonViaCep.logradouro);
        setLocalidade(jsonViaCep.localidade);
        setUf(jsonViaCep.uf);
        setBairro(jsonViaCep.bairro);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSiglaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valor = e.target.value;
    const valorFiltrado = valor.replace(/[^a-zA-Z0-9-]/g, '');
    setSigla(valorFiltrado)
  };

  useEffect(() => {
    listarMatrizesAtivas();
    if (tipo === 'alteracao') {
      listarOriginadorPorId();
    }
  }, [id, tipo]);

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => { setAlert(null); if (alert.type === 'success') { window.history.back(); } }} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Origens &gt; {Originador.DESCRITIVO_GERAL} &gt; Inclusão</h5> : (
                <h5>Origens &gt; {Originador.DESCRITIVO_GERAL} &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <Row className="mb-3">
            <div className="col-xl-6">
              <label>Matriz <span style={{ color: 'red' }}>*</span></label>
              <select required className="form-select" value={idMatriz} onChange={(e) => setIdMatriz(e.target.value)}>
                <option value="" disabled>Selecione uma Matriz</option>
                {matrizes.map((matriz) => (
                  <option key={matriz.id} value={matriz.id!}>
                    {matriz.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-xl-6">
              <label>Sigla <span style={{ color: 'red' }}>*</span></label>
              <input
                required
                type="text"
                className="form-control"
                value={sigla}
                onChange={handleSiglaChange}
                disabled={tipo === 'alteracao'}
              />
            </div>
            <div className="col-md">
              <label>Razão Social <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={razaoSocial} onChange={(e) => setRazaoSocial(e.target.value)} />
            </div>
          </Row>

          <Row className="mb-3">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';') <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
          </Row>

          <hr className="my-4" />
          <h5 className="mb-3">Dados Bancários</h5>
          
          <div className="row">
            <div className="col-md-2">
              <label>Cód. Banco <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" placeholder="341" maxLength={3}
                value={codigoBanco} onChange={e => setCodigoBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-4">
              <label>Nome do Banco</label>
              <input type="text" className="form-control" placeholder="Itaú Unibanco" 
                value={nomeBanco} onChange={e => setNomeBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label>Agência (sem dígito)</label>
              <input type="text" className="form-control" maxLength={5}
                value={agencia} onChange={e => setAgencia(e.target.value)} 
              />
            </div>
            <div className="col-md-3">
              <label>Conta Corrente</label>
              <input type="text" className="form-control" maxLength={15}
                value={conta} onChange={e => setConta(e.target.value)} 
              />
            </div>
            <div className="col-md-1">
              <label>Dígito</label>
              <input type="text" className="form-control" maxLength={2}
                value={digitoConta} onChange={e => setDigitoConta(e.target.value)} 
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-2">
              <label>Tipo Conta</label>
              <select className="form-select" value={tipoConta} onChange={e => setTipoConta(e.target.value)}>
                <option value="CORRENTE">Corrente</option>
                <option value="POUPANCA">Poupança</option>
              </select>
            </div>
            <div className="col-md-4">
              <label>Forma de Pagamento <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={camaraCentralizadora} onChange={e => setCamaraCentralizadora(e.target.value)}>
                <option value="018">TED (STR)</option>
                <option value="000">Mesmo Banco (CC)</option>
                <option value="009">PIX</option>
                <option value="888">TED (CIP)</option>
              </select>
            </div>
            {camaraCentralizadora === '009' && (
              <div className="col-md-6">
                <label>Chave PIX <span style={{ color: 'red' }}>*</span></label>
                <input type="text" className="form-control" placeholder="Email, CPF/CNPJ, Celular ou Chave Aleatória"
                  value={chavePix} onChange={e => setChavePix(e.target.value)} 
                  required={camaraCentralizadora === '009'}
                />
              </div>
            )}
          </div>
          
          <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-info py-2 small mb-0">
                <strong><i className="bi bi-info-circle-fill me-2"></i>Informação:</strong> {explicacoesPagamento[camaraCentralizadora]}
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <Row className="mb-3">
            <div className="col-md-2">
              <label>CEP <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="99.999-999" type="text" className="form-control" required
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número <span style={{ color: 'red' }}>*</span></label>
              <input type="number" className="form-control" required value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </Row>

          <Row className="mb-3">
            <div className="col-md">
              <label>Bairro <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="aa" type="text" required className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </Row>

          <hr className="my-4" />

          <Row className="mb-3">
            <div className="col-md">
              <label className="form-label">Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
            </div>
            <div className="col-md">
              <label className="form-label">Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
            </div>
          </Row>

          <hr className="my-4" />
          <h5 className="mb-3">Carta DED</h5>
          <Row className="mb-3">
            <div className="col-md-6">
              <label>Contato</label>
               <InputMask mask="9999 999 9999" type="text" className="form-control" value={cartaDedContato} onChange={(e) => setCartaDedContato(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label>E-mail</label>
              <input type="email" className="form-control" value={cartaDedEmail} onChange={(e) => setCartaDedEmail(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label>Whatsapp</label>
               <InputMask mask="(99)99999-9999" type="text" className="form-control" value={cartaDedWhatsapp} onChange={(e) => setCartaDedWhatsapp(e.target.value)} />
            </div>
          </Row>

          <hr className="my-4" />
          <Row className="mb-3">
            <ImageUploader
              onImageChange={handleLogoChange}
              initialImageUrl={logoBase64 || undefined}
            />

            <ColorPicker
              label="Cor Primaria"
              onColorChange={setCorPrincipal}
              initialColor={corPrincipal}
            />
            <Col md={6} className="mb-3">
              <ColorPicker
                label="Cor Secundária"
                onColorChange={setCorSecundaria}
                initialColor={corSecundaria}
              />
            </Col>
            <Col md={6} className="mb-3">
              <ColorPicker
                label="Cor Texto"
                onColorChange={setCorTexto}
                initialColor={corTexto}
              />
            </Col>
            <Col md={6} className="mb-3">
              <ColorPicker
                label="Cor Cabeçalho"
                onColorChange={setCorCabecalho}
                initialColor={corCabecalho}
              />
            </Col>
            <Col md={6} className="mb-3">
              <ColorPicker
                label="Cor Tabela"
                onColorChange={setCorTabela}
                initialColor={corTabela}
              />
            </Col>
          </Row>
          <hr className="my-4" />

          <Row className="mb-3">
            <div className="col-md-6">
              <label>Código Externo</label>
              <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
            </div>
          </Row>

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
              <button type="button" onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? `Alterar ${Originador.DESCRITIVO_GERAL}` : `Salvar ${Originador.DESCRITIVO_GERAL}`}</button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default OriginadorInclusaoAlteracao;